import { Voicemail } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useUserState } from '~/atoms/UserState'
import { SiteNavigationTab } from '~/pages/Home/SiteNavigation/shared/SiteNavigationTab'
import { TabImplementationProps } from '~/pages/Home/SiteNavigation/tabImplementations/TabImplementationTypes'
import { useVoicemailViewModel } from '~/viewModels/Voicemail/VoicemailViewModel'

export const VoicemailTab = ({
  id,
  isSelected,
  isCollapsed,
  onClick,
}: TabImplementationProps) => {
  const {
    voicemailViewModel: { unreadVoicemailsCount },
    actions,
  } = useVoicemailViewModel()
  const { t } = useTranslation()
  const { pbxId } = useUserState()

  // on mount and pbxId change, fetch voicemail extensions
  React.useEffect(() => {
    actions.fetchVoicemailExtensions()
  }, [isSelected, pbxId])

  return (
    <SiteNavigationTab
      id={id}
      title={t('nav.voicemail')}
      icon={Voicemail}
      isSelected={isSelected}
      isCollapsed={isCollapsed}
      onClick={onClick}
      notificationCount={unreadVoicemailsCount}
    />
  )
}
